











import { Component, Mixins } from "vue-property-decorator";
import { ModelEditableMixin } from "../../../../../base/components/system";
import { IGroupAlertBehavior } from "../../../../domain/format/objects";
import { default as OptionalFeatureEditor } from "./OptionalFeatureEditor.vue";

@Component({
  components: {
    OptionalFeatureEditor,
  },
})
export default class GroupAlertBehaviorEditor extends Mixins(ModelEditableMixin) {
  // ModelEditableMixinと同時に使う事.ModelEditableMixin利用APIの宣言.
  writePropertyWhenValid: (writer: (source: IGroupAlertBehavior) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: IGroupAlertBehavior) => T, defaultValue: T) => T;

  $refs!: {
    input: HTMLInputElement;
  };

  get isEnable(): boolean {
    return this.readPropertyOrDefault(s => s.isEnable, false);
  }

  get name(): string {
    return this.readPropertyOrDefault(s => s.name, "");
  }

  set name(value: string) {
    this.writePropertyWhenValid(s => s.name = value);
  }
}
